import logo from './logo.svg';
import './App.css';
import store from './store';
import {Provider} from 'react-redux';
import Navheader from './Components/Navheader';
import Background from './Components/Background';
import Element from './Components/Element';
import styles from './Components/styles.module.scss';
import Button from './Components/Button';
import Card from './Components/Card';
import Footer from './Components/Footer';
import Vid from './Components/Vid';
import PasswordInput from './Components/PasswordInput';
import Modal from './Components/Modal';
import { useState } from 'react';
function Gallery(props) {
const [modal,setModal] = useState(null);
  const gameArray = props.games;
  const gameCardsArray = props.gameCards;
   const horrorGameArray = props.horrorGames;

  const images = [
    "anniversary.jpg",
    "calamities.jpg",
    "creepypast.jpg",
    "dirgryb.jpg",
    "manga1.jpg",
    "manga2.jpg",
    "rosc1.jpg",
    "solena.jpg",
    "sonia1.jpg",
    "fboy1.png",
    "fboy2.png",
    "hnia1.png",
    "janitor1.png",
    "kucyki1.png",
    "kucyki2.png",
    "michael1.png",
    "mr3.png",
    "mushroomy1.png",
    "patol1.png",
    "poof1.png",
    "poofboy.png",
    "sonia1.png",
    "sonia2.png",
    "tealen1.png",
    "tail.png",
    "geezis.png",
    "tubby.png",
    "swag.png",
    "dirgryb2.png",
    "roscis.png",
    "gombra.png",
    "zaak.png",
    "stach.png",
    "janita.png",
    "cubus.png",
    "gpoof.png",
    "gpuppet.png",
    "fax.png",
    "konfident.png",
    "fisoret.png",
    "capcake.png",
    "logopeda.png",
    "adam.png",
    "uther1.png",
    "princess.png",
    "hazbin.jpg",
    "vuctor1.png"
  ];




let itemsArray = [];
let itemsBiggerArray = [];
const openModal = (e) => {
  console.log(e.target.id);
  let x = parseInt(e.target.id) - 1;
  console.log(x);
  setModal(itemsBiggerArray[x]);
  
}
const closeModal = () => {
  setModal(null);
}
images.forEach((e,i)=>{
  itemsArray.push(<img onClick={openModal} id={i + 1} className={`${styles.galleryItem} ${styles['galleryItem--normal']}`} src={`/pictures/gallery/${images[i]}`}/>)
});

images.forEach((e,i)=>{
  itemsBiggerArray.push(<img onClick={openModal} id={i + 1} className={`${styles.galleryItem} ${styles['galleryItem--bigger']}`} src={`/pictures/gallery/${images[i]}`}/>)
});


  return (

    <div className="App"
    style={{
      width: '100%',
      background:'black',
      overflowX: "hidden"
    }}>
    <Background halloween={props.halloween} xmas={props.xmas} ></Background>
    <Element  halloween={props.halloween} xmas={props.xmas} height={"10P"} background={2}></Element><br/>
        <div className={`${styles[`h2`]}`}>Poof's Killergarten Gallery</div>
        <br/>
        {modal != null && <Modal  halloween={props.halloween} xmas={props.xmas} click={closeModal}>{modal}</Modal>}
       <div className={`${styles.fateItemList}`}>
             {itemsArray}
                 <Footer halloween={props.halloween} xmas={props.xmas} ></Footer>
       </div>
    <Element  halloween={props.halloween} xmas={props.xmas} height={"100P"} background={5} flexColumn={true}></Element>
    <Element  halloween={props.halloween} xmas={props.xmas} height={"100P"} background={5} flexColumn={true}></Element>
        <Element  halloween={props.halloween} xmas={props.xmas} height={"100P"} background={5} flexColumn={true}></Element>
                <Element  halloween={props.halloween} xmas={props.xmas} height={"100P"} background={5} flexColumn={true}></Element>
                <Element  halloween={props.halloween} xmas={props.xmas} height={"100P"} background={5} flexColumn={true}></Element>
                  <Element  halloween={props.halloween} xmas={props.xmas} height={"10P"} background={5} flexColumn={true}></Element>



       
                        
                                  <Element  halloween={props.halloween} xmas={props.xmas} height={"10P"} background={1}></Element>


        

    <Navheader halloween={props.halloween} xmas={props.xmas} games={gameArray} horrorGames={horrorGameArray}></Navheader>
   
    </div>

    
  );
}

export default Gallery;
